import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { ContentPiece } from "../../../shared/types";

export function useApprovePiece() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pieceId: string) =>
      api.post<{ data: ContentPiece }>(
        `/api/content/pieces/${pieceId}/approve`,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["content-runs"] });
    },
  });
}

export function useRejectPiece() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pieceId: string) =>
      api.post<{ data: ContentPiece }>(
        `/api/content/pieces/${pieceId}/reject`,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["content-runs"] });
    },
  });
}

export function useRegeneratePiece(runId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: { platform: string }) =>
      api.post<{ data: ContentPiece }>(
        `/api/content/runs/${runId}/regenerate`,
        payload,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["content-runs"] });
    },
  });
}
